import React, { useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLocale } from '../components/LocaleProvider';

export default function ResetPassword() {
  const { locale } = useLocale();
  const es = locale === 'es';
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const email = useMemo(() => params.get("email") || "", [params]);
  const token = useMemo(() => params.get("token") || "", [params]);
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  async function submit(event) {
    event.preventDefault();
    if (password.length < 8) return setMessage(es ? 'La contraseña debe tener al menos 8 caracteres.' : "A senha deve ter pelo menos 8 caracteres.");
    if (password !== confirmation) return setMessage(es ? 'Las contraseñas no coinciden.' : "As senhas não conferem.");
    if (!token) return setMessage(es ? 'Este enlace para crear la contraseña está incompleto o venció.' : "Este link de criação de senha está incompleto ou expirou.");
    setBusy(true);
    setMessage("");
    try {
      const response = await fetch("/api/auth/reset-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, token, newPassword: password }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(es ? 'No fue posible crear la contraseña.' : (payload.error || "Não foi possível criar a senha."));
      setMessage(es ? 'Contraseña creada. Ya puedes iniciar sesión con correo y contraseña.' : "Senha criada com sucesso. Agora você pode entrar sem OTP.");
      window.setTimeout(() => navigate("/pro?access=login#acesso"), 1000);
    } catch (error) {
      setMessage(es ? 'No fue posible crear la contraseña. Revisa el enlace e inténtalo de nuevo.' : error.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="mx-auto min-h-[64vh] max-w-md px-4 py-20">
      <section className="rounded-3xl border border-[var(--border)] bg-[var(--surface)] p-7 shadow-sm">
        <p className="text-xs font-semibold text-[var(--text-muted)]">{es ? 'Seguridad de la cuenta' : 'Segurança da conta'}</p>
        <h1 className="mt-3 text-[var(--primary)]">{es ? 'Crear contraseña' : 'Criar senha'}</h1>
        <p className="mt-3 text-sm text-[var(--text-muted)]">{es ? 'Usa al menos 8 caracteres. Después, inicia sesión con tu correo y contraseña.' : 'Use pelo menos 8 caracteres. Depois, entre com e-mail e senha sempre que quiser.'}</p>
        <form onSubmit={submit} className="mt-6">
          <label className="block text-sm font-bold text-[var(--primary)]" htmlFor="new-password">{es ? 'Nueva contraseña' : 'Nova senha'}</label>
          <input id="new-password" required minLength={8} type="password" autoComplete="new-password" value={password} onChange={(event) => setPassword(event.target.value)} className="input-field mt-2" />
          <label className="mt-4 block text-sm font-bold text-[var(--primary)]" htmlFor="confirm-password">{es ? 'Confirmar contraseña' : 'Confirmar senha'}</label>
          <input id="confirm-password" required minLength={8} type="password" autoComplete="new-password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} className="input-field mt-2" />
          <button disabled={busy} className="mt-5 w-full rounded-xl bg-[var(--accent)] p-3 font-bold text-[var(--on-accent)] disabled:opacity-60">{busy ? (es ? 'Guardando…' : 'Salvando…') : (es ? 'Guardar contraseña' : 'Salvar senha')}</button>
        </form>
        {message && <p role="status" className="mt-4 text-sm text-[var(--text-muted)]">{message}</p>}
      </section>
    </main>
  );
}
